export enum AdvisoryBuyerModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
